import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ClientDetails } from 'src/app/site/feature-modules/profile/models/profile';
import { EditAccountService } from 'src/app/site/shared-components/edit-account/edit-account.service';
import { ProfileService } from 'src/app/site/feature-modules/profile/services/profile.service';
import { LoadClientDetails, UpdateClientDetails } from './client-details.action';
import { ClientDetailsImpl } from '../../classes/clientDetails-class';

export interface ClientDetailsStateModel {
  clientDetails: ClientDetails;
}

@State<ClientDetailsStateModel>({
  name: 'clientDetails',
  defaults: {
    clientDetails: new ClientDetailsImpl({}),
  }
})
@Injectable()
export class ClientDetailsState {

  constructor(private editAccountService: EditAccountService, private profileService: ProfileService) {}

  @Selector()
  static getClientDetails(state: ClientDetailsStateModel) {
    return state.clientDetails || new ClientDetailsImpl({});
  }

  @Action(LoadClientDetails)
  loadClientDetails(ctx: StateContext<ClientDetailsStateModel>) {
    return this.profileService.getCLientDetails().pipe(
      tap((response) => {
        const clientDetails = response.data ? new ClientDetailsImpl(response.data) : new ClientDetailsImpl({});
        ctx.patchState({ clientDetails: clientDetails });
      })
    );
  }

  @Action(UpdateClientDetails)
  updateClientDetails(ctx: StateContext<ClientDetailsStateModel>, action: UpdateClientDetails) {
    return this.editAccountService.updateProfile(action.payload).pipe(
      tap((response) => {
        const updatedClientDetails = response.data ? new ClientDetailsImpl(response.data) : ctx.getState().clientDetails;
        ctx.patchState({ clientDetails: updatedClientDetails });
      })
    );
  }
}
